'use client';

import classes from "./public_header_nav.module.css";
import { Offcanvas } from 'react-bootstrap';
import SvgX from '@/assets/svg/icons/x.svg';
import CustomSVG from "@/components/common/svg";
import PublicHeaderNavItems from "./public_header_nav_items";
import PublicHeaderButtons from "./public_header_buttons";
import { useSession } from "next-auth/react";
import { useContext } from "react";
import AuthContext from "@/providers/auth-context";
import { useMobileApp } from "@/providers/mobile-app-context";
import Avatar from "@/components/common/avatar/avatar";
import Link from "next/link";
import BrandLogo from '@/components/common/brand_logo/brand_logo';

async function triggerNavHaptic() {
    try {
        const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
        await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
        // no-op on web / unsupported platforms
    }
}

export default function NavAside({show, setShow}) {
    const {data, status} = useSession();
    const userData = useContext(AuthContext);
    const { isNativeApp } = useMobileApp();

    const close = () => {
        if (isNativeApp) triggerNavHaptic();
        setShow(false);
    }

    return <Offcanvas show={show} placement={"start"} backdropClassName={classes.backdrop} onHide={close} className={`${classes.asideLeft} ${isNativeApp ? classes["native-aside"] : ""}`}>
        <Offcanvas.Header className="d-flex align-items-center flex-column align-self-stretch gap-4 padding-0 padding-top-2 padding-bottom-4">
            <div className="d-flex align-items-center flex-row justify-content-between align-self-stretch padding-x-4">
                <div style={{width: 40}} />
                <BrandLogo variant="stacked" />
                <CustomSVG className="stroke-gray-800 padding-2 pointer" SvgFunction={SvgX} height={40} width={40} onClick={close} />
            </div>
            {isNativeApp && (status === "authenticated" && data?.user
                ? <Link href="/profilom" onClick={close} className={`${classes["native-account-row"]} text-decoration-none w-100`}>
                    <Avatar size="md" url={userData.userData.photo} />
                    <div className="d-flex flex-column align-items-start overflow-hidden">
                        <span className="text-sm-semibold color-gray-800 text-truncate w-100">{userData.userData.name}</span>
                        <span className="text-xs-regular color-gray-500 text-truncate w-100">{userData.userData.email}</span>
                    </div>
                </Link>
                : <div className="d-flex flex-column align-self-stretch gap-2 padding-x-4 w-100">
                    <PublicHeaderButtons noArrow onClick={close} mobile />
                </div>
            )}
        </Offcanvas.Header>
        <Offcanvas.Body className={`${classes["nav-body"]}`}>
            <h3 className="margin-0 text-xs-regular color-gray-500 text-uppercase">Főoldal</h3>
            <div className={`${classes["nav-body-main"]}`}>
                <PublicHeaderNavItems onClick={close} is_mobile={true} />
            </div>
            {/*removed temporarily --- <div className="divider-300"></div>*/}
            {/*removed temporarily --- (status === "authenticated" && data.user)
                ? <>
                    <PublicHeaderItem href="/profilom">Profil beállítások</PublicHeaderItem>
                    <PublicHeaderItem href="" onClick={signOut}>Kijelentkezés</PublicHeaderItem>
                </>
                : <PublicHeaderButtons noArrow onClick={() => setShow(false)} mobile />
            */}
        </Offcanvas.Body>
    </Offcanvas>
}